var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Photo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_566_2367",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5798 19.4097L2.5598 19.4297C2.2898 18.8397 2.1198 18.1697 2.0498 17.4297C2.1198 18.1597 2.3098 18.8197 2.5798 19.4097Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.5798 19.4097L2.5598 19.4297C2.2898 18.8397 2.1198 18.1697 2.0498 17.4297C2.1198 18.1597 2.3098 18.8197 2.5798 19.4097Z",
    fill: "#6C84F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5798 19.4097L3.28692 20.1168L3.77827 19.6254L3.48911 18.9936L2.5798 19.4097ZM2.5598 19.4297L1.6505 19.8458L2.24934 21.1544L3.26692 20.1368L2.5598 19.4297ZM2.0498 17.4297L3.04524 17.3342L1.05425 17.5239L2.0498 17.4297ZM1.87269 18.7026L1.85269 18.7226L3.26692 20.1368L3.28692 20.1168L1.87269 18.7026ZM3.46911 19.0136C3.25237 18.5399 3.10646 17.9814 3.04536 17.3355L1.05425 17.5239C1.13315 18.358 1.32724 19.1394 1.6505 19.8458L3.46911 19.0136ZM1.05437 17.5251C1.1355 18.3712 1.35632 19.1393 1.6705 19.8258L3.48911 18.9936C3.26329 18.5001 3.10411 17.9482 3.04524 17.3342L1.05437 17.5251Z",
    fill: "#6C84F8",
    mask: "url(#path-1-inside-1_566_2367)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.8801 8.40002C10.8801 9.43832 10.0384 10.28 9.00012 10.28C7.96182 10.28 7.12012 9.43832 7.12012 8.40002C7.12012 7.36172 7.96182 6.52002 9.00012 6.52002C10.0384 6.52002 10.8801 7.36172 10.8801 8.40002Z",
    fill: "#6C84F8",
    stroke: "#C080FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.01551 19.2237L3.01553 19.2237L3.01381 19.22C2.68003 18.4983 2.5 17.6226 2.5 16.5899V8.2099C2.5 6.48934 3.01093 5.17608 3.89355 4.29346C4.77618 3.41083 6.08944 2.8999 7.81 2.8999H16.19C17.9106 2.8999 19.2238 3.41083 20.1064 4.29346C20.9891 5.17608 21.5 6.48934 21.5 8.2099V14.2999V16.5899C21.5 18.3105 20.9891 19.6237 20.1064 20.5063C19.2238 21.389 17.9106 21.8999 16.19 21.8999H7.81C5.41093 21.8999 3.77734 20.9068 3.01551 19.2237ZM20.0442 13.2792L20.047 13.2816L20.177 13.3916L21 14.088V13.0099V8.2099C21 6.71583 20.6043 5.49212 19.7561 4.64385C18.9078 3.79558 17.6841 3.3999 16.19 3.3999H7.81C6.31593 3.3999 5.09221 3.79558 4.24395 4.64385C3.39568 5.49212 3 6.71583 3 8.2099V16.5899C3 17.4084 3.14029 18.1208 3.38462 18.7427L3.61209 19.3217L4.12863 18.9751L7.86863 16.4651L7.86974 16.4643C8.48811 16.0469 9.36764 16.1007 9.90112 16.5665L9.90657 16.5713L9.91215 16.5759L10.2484 16.8527C11.216 17.6801 12.7498 17.679 13.7158 16.8492L17.8756 13.2793L17.8758 13.2792C18.4684 12.7701 19.4516 12.7701 20.0442 13.2792Z",
    fill: "#6C84F8",
    stroke: "#6C84F8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.c2f2f715d63ff2cd239efe0cea3824ee.svg";
export { ForwardRef as ReactComponent };